import styled from 'styled-components';
import gameLogo from 'assets/images/game_logo.min.png';
export const SWrapper = styled.section`
  max-width: 600px;
  margin: 0 auto;
  transform: translate(calc(var(--sidebar-width) / 2), 0);
  position: relative;
  z-index: 10;

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    padding: 0 10px;
    transform: translate(0, 0);
  }
`;

export const SSidebar = styled.aside`
  position: absolute;
  top: 0;
  width: 340px;
  z-index: 1;
  margin-left: -350px;
  user-select: none;
  margin-top: var(--header-height);

  [data-box='intro'] {
    max-height: 660px;
  }

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    position: relative;
    margin-left: 0;
    width: 100%;
    margin-top: 0;

    [data-box='toasts'] {
      display: none;
    }
  }

  @media (max-width: 540px) and (max-aspect-ratio: 1/1) {
    margin-bottom: 40px;
  }
`;

export const SContent = styled.section``;

export const SWinInfo = styled.div`
  color: rgb(144, 144, 149);
  padding: 5px 0px 20px;
  font-size: 15px;
  text-align: center;
`;

export const SDownTimerText = styled.div`
  color: rgb(255, 227, 16);
  text-align: center;
  font-size: 15px;
  margin: -10px 0 10px;

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    margin: 0 0 4px;
  }
`;

export const SBox = styled.section`
  flex: 0 0 100%;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 20px;
  background: var(--primary-color);

  &[data-box='informer-header'] {
    background: none;
    display: none;
    padding: 10px 0;

    button {
      background: none;
      flex: 0 1;
    }

    button:first-child {
      flex: 0 1 !important;
      margin-right: auto;
      min-width: 150px;
    }
  }

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    border-radius: 0 0 8px 8px;
    padding: 0 10px 10px;

    &[data-box='informer'] {
      display: none;
    }

    &[data-box='informer-header'] {
      display: block;
      padding: 10px 0 0 10px;

      button {
        flex: 0 0 45px !important;
        min-height: 45px;
        padding: 6px 0;
      }
    }
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    padding: 10px;

    &[data-box='informer-header'] {
      padding: 0;
    }
  }
`;

export const SGameLogo = styled.span`
  display: block;
  position: absolute;
  width: 450px;
  height: 150px;
  bottom: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('${gameLogo}');

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    width: 180px;
    height: 60px;
  }
`;

export const SLobbyWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 10px;
`;

export const SLobbyLink = styled.a`
  padding: 4px 6px 3px;
  border: 2px solid var(--btn-bg-active);
  color: var(--inverse-color);
  text-transform: uppercase;
  text-decoration: none;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  border-radius: 4px;
`;
